<template>
    <v-btn-toggle v-model="query.type" borderless active-class="white elevation-4" color="primary" class="cash-list-type grey lighten-4" style="width:100%;border-radius:8px!important" @change="emit">
        <template v-for="{ text, value } in types">
            <v-btn :width="`calc(100% / ${types.length})`" style="border-radius: 8px!important;" v-bind="{ value }" :key="text"> {{ text }} </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import { mapState } from "vuex";
const initQuery = (form = {}) => ({
    ...(form || {}),
    type: form?.type || null,
});

export default {
    data: () => ({
        query: initQuery(),
    }),
    computed: {
        ...mapState({ hasMarginCash: (store) => store?.user?.hasMarginCash }),
        types() {
            return [
                { text: "전체", value: null },
                { text: "마진", value: "mrg", shows: this.hasMarginCash ?? false },
                { text: "충전", value: "inc" },
                { text: "사용 (선물)", value: "dec" },
                { text: "리워드 캐시충전", value: "rwd" },
            ].filter((item) => item.shows ?? true);
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.type) delete query.type;

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
// 탭 너비는 똑같이(100% / 탭 수) 나누므로, 모바일에서 칸보다 긴 이름("리워드 캐시충전")이 옆 탭 위로 넘쳤다.
// 칸 안에서 낱말 단위로 줄을 바꾸고, 두 줄이 되면 탭 높이를 늘린다
.cash-list-type > .v-btn {
    min-width: 0 !important;
    min-height: 48px;
    height: auto !important;
    padding: 4px !important;
    white-space: normal;

    ::v-deep .v-btn__content {
        flex: 1 1 auto;
        white-space: normal;
        word-break: keep-all;
        line-height: 1.3;
    }
}
</style>
